import React from 'react'
import {APP_DOMAIN} from '../../constants/constants';

export const CrownBox = () =>{
    return(
        <div className="crown-box">
            <img src={`${APP_DOMAIN}/assets/images/crown.svg`}/>
            <span>PREMIUM</span>
        </div>
    );
}